import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { HeaderRemindersEffects } from './header-reminders-effects';
import { headerRemindersFeature } from './header-reminders-feature';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(headerRemindersFeature),
    EffectsModule.forFeature(HeaderRemindersEffects)
  ]
})
export class HeaderRemindersFeatureStoreModule {
}
